export enum CreditCardControlState {
    ReadMode = 1,
    ReCaptchaValidation = 2,
    EditMode = 3
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/user-controls/credit-card-control-state.ts